import type { FaireProductEntity } from "../../entity_types/product";

export const p_b7mcw4zp8w: FaireProductEntity = {
  token: "p_b7mcw4zp8w",
  type: "product",
  name: "Sequin Bow Ring Top Handle Crossbody Bag",
  brandToken: "b_3jxtednxl5",
  brandName: "OMG Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/b520328765b0de9f088db7a8e73392e3a04403f7f9c41b450836645975448fc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8cd5a28bb3f038e4dacc12b930b59c63ec00e35f4fd573e84cafd6093b745cf0.jpeg",
  ],
  priceDollars: 16,
  description:
    ' Add glitter & shine to their next outfit with our circular rhinestone top handle! This crossbody is crafted in our white metallic quilt, with a big, sparkly bow on the sequin covered front flap, & a spacious main pocket! Topped off with our adjustable crossbody strap for easy carrying!\n\nMeasures Approx. -5.25"H x 6.625"W x 2.50"D\nManufacturer Style No. - BOW-MTH85\n',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:28.099Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
